export default __webpack_public_path__ + "static/media/count1.907cac51.jpg";